import { render, staticRenderFns } from "./PorEquipe.vue?vue&type=template&id=68237520"
import script from "./PorEquipe.vue?vue&type=script&lang=js"
export * from "./PorEquipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports